import { shouldRenderOnCurrentView } from '@hts/shared/utils';
import { useIsMobile } from './useIsMobile';

export const useShouldRenderOnCurrentView = (desktop: boolean = false, mobile: boolean = false) => {
  const isMobile = useIsMobile();

  return shouldRenderOnCurrentView(isMobile, desktop, mobile);
};
